export const summarySecurityLogs = (state: any) => {
    return state.summarySecurityLogs;
}
export const isFetchingSummary = (state: any) => {
    return state.isFetchingSummary;
}
export const summaryError = (state: any) => {
    return state.summaryError;
}
